import React, { useState, useEffect } from 'react';
import './style/UserManagementPage.css'; // стили
import NavBarAdmin from './NavBarAdmin';
import config from './config/config';
import { useNavigate } from "react-router-dom";

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут
const API_BASE = `${config.apiUrl2}/api/services`;

const initialForm = {
    name: '',
    description: '',
    price: '',
};

function ServiceManagementPage() {
    const [services, setServices] = useState([]);
    const [formData, setFormData] = useState(initialForm);
    const [editId, setEditId] = useState(null);
    const navigate = useNavigate();

    // 🔐 Проверка сессии
    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);

            if (diff > SESSION_TIMEOUT) {
                // сессия истекла
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/panel/admin-panel');
            }
        } else {
            // если не авторизован
            navigate('/panel/admin-panel');
        }
    }, [navigate]);

    // 📥 Загрузка услуг
    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const res = await fetch(API_BASE);
            if (!res.ok) throw new Error("Ошибка загрузки");
            const data = await res.json();
            setServices(data);
        } catch (error) {
            console.error('Ошибка при получении услуг:', error);
        }
    };

    // 🔄 Изменение формы
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    // ✏️ Редактирование
    const handleEdit = (service) => {
        setEditId(service.id);
        setFormData({
            name: service.name || '',
            description: service.description || '',
            price: service.price?.toString() || '',
        });
    };

    // ❌ Отмена редактирования
    const handleCancel = () => {
        setEditId(null);
        setFormData(initialForm);
    };

    // 🗑️ Удаление
    const handleDelete = async (id) => {
        if (window.confirm('Удалить услугу?')) {
            try {
                await fetch(`${API_BASE}/${id}`, { method: 'DELETE' });
                fetchServices();
            } catch (err) {
                console.error("Ошибка удаления:", err);
            }
        }
    };

    // 💾 Создание / Обновление
    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editId ? 'PUT' : 'POST';
        const url = editId ? `${API_BASE}/${editId}` : API_BASE;

        const payload = {
            name: formData.name,
            description: formData.description,
            price: parseFloat(formData.price),
        };

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error("Ошибка при сохранении");

            fetchServices();
            setFormData(initialForm);
            setEditId(null);
        } catch (err) {
            console.error('Ошибка сохранения:', err);
            alert('Произошла ошибка при сохранении');
        }
    };

    return (
        <div className="user-mng-page">
            <header className="header">
                <NavBarAdmin />
            </header>

            <div className="profile-container">
                <h2>{editId ? 'Редактировать услугу' : 'Создать услугу'}</h2>
                <form onSubmit={handleSubmit} className="form-container">
                    <input
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Название"
                        required
                    />
                    <input
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Описание"
                    />
                    <input
                        name="price"
                        type="number"
                        value={formData.price}
                        onChange={handleChange}
                        placeholder="Цена"
                        required
                        step="0.01"
                    />
                    <div className="button-group">
                        <button type="submit" className="order-btn">
                            {editId ? 'Обновить' : 'Создать'}
                        </button>
                        {editId && (
                            <button type="button" className="logout-btn" onClick={handleCancel}>
                                Отмена
                            </button>
                        )}
                    </div>
                </form>

                <h3>Список услуг</h3>
                <table className="history-table">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Название</th>
                        <th>Описание</th>
                        <th>Цена</th>
                        <th>Создана</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {services.map(service => (
                        <tr key={service.id}>
                            <td>{service.id}</td>
                            <td>{service.name}</td>
                            <td>{service.description}</td>
                            <td>{service.price} сум</td>
                            <td>{new Date(service.createdAt).toLocaleString()}</td>
                            <td>
                                <button onClick={() => handleEdit(service)}>✏️</button>
                                <button onClick={() => handleDelete(service.id)}>🗑️</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ServiceManagementPage;
